import { useEffect, useState } from "react";
import { Get } from "../services/api";
import { toast } from "react-toastify";
import { formatDigit } from "./format.util";
import config from "../../utils/config";
const { imageUrl } = config;

const SpotBalance = ({ refresh, socket }) => {
  const [data, set_data] = useState([]);

  useEffect(() => {
    console.log("spotList");
    if (!localStorage.getItem("jwtToken")) return;
    console.log("spotList");

    socket.emit(
      "get_spot_balance_list", // event name from your backend
      {}, // socket_body (empty since no params needed)
      (response) => {        
        // callback from backend
        if (response?.status) {
          set_data(response.data); // response.data is array from SQL
        } else {
          toast.error("Failed to spot Balance");
        }
      }
    );
  }, [refresh]);

  return (
    <>
      <div className="ne_box  h-100 ">
        <h6 className="h6_head">Spot Balance</h6>
        <div className="balance-outer scrollStyle ">
          <table className="w-100">
            <tbody>
              {data?.map((data, i) => (
                <tr key={i}>
                  <td>
                    <img
                      className="currency_icon"
                      // src={baseUrl + "/static/currencyImage/" + item.currency_image}
                      src={`${imageUrl}/images/${data?.symbol
                        ?.split("/")[0]
                        ?.toLowerCase()}.svg`}
                      // src={`https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${item.pair.split('/')[0].toLowerCase()}.svg`}
                      onError={(e) =>
                        (e.target.src =
                          "https://dummyimage.com/40x40/cccccc/000000.png&text=ven")
                      }
                    />
                    {data.symbol}
                  </td>
                  <td>{formatDigit(data.spot_balance)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export { SpotBalance };
